import { MapPin, MessageCircle } from "lucide-react";
import { ASSETS, COMPANY, generalWhatsAppUrl, scrollToSection } from "@/data/products";

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-forest-deep">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, #cbae83 0, transparent 40%), radial-gradient(circle at 85% 75%, #3e6b52 0, transparent 45%)",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-4 py-16 sm:px-6 md:py-24 lg:grid-cols-[1.15fr_0.85fr]">
        <div>
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-bronze/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-bronze-light">
            Fishing Tackle Retailer
          </p>
          <h1 className="font-display text-4xl font-semibold leading-tight text-cream sm:text-5xl lg:text-6xl">
            Gear Up for Your Next Fishing Adventure
          </h1>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-cream/80 sm:text-base">
            RIMBARA MAJU SDN BHD is a Malaysian retail business based in Sungai
            Petani, Kedah, focused on fishing equipment, selected online retail
            products and second-hand goods. Browse our fishing catalogue and
            contact us for product details and purchasing enquiries.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <button
              type="button"
              onClick={() => scrollToSection("products")}
              className="rounded-full bg-bronze px-7 py-3 text-sm font-semibold text-white shadow-lg shadow-black/20 transition-colors hover:bg-bronze-dark"
              data-testid="hero-explore-products"
            >
              Explore Products
            </button>
            <a
              href={generalWhatsAppUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-cream/40 px-7 py-3 text-sm font-semibold text-cream transition-colors hover:border-cream hover:bg-cream/10"
              data-testid="hero-whatsapp-button"
            >
              <MessageCircle className="h-4 w-4" aria-hidden="true" />
              WhatsApp Us
            </a>
          </div>
          <p className="mt-8 inline-flex items-center gap-2 text-sm text-cream/70">
            <MapPin className="h-4 w-4 text-bronze-light" aria-hidden="true" />
            {COMPANY.location}
          </p>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-2xl border border-bronze/30 bg-white shadow-2xl shadow-black/30">
            <img
              src={ASSETS.hero}
              alt="Daiwa Saltiga 15HL-SJ overhead jigging reel from the RIMBARA MAJU catalogue"
              className="aspect-[4/3] w-full object-contain p-6"
              loading="eager"
              data-testid="hero-product-image"
            />
          </div>
          <p className="mt-4 text-center text-xs uppercase tracking-[0.2em] text-cream/50">
            From our fishing catalogue
          </p>
        </div>
      </div>
    </section>
  );
}
